import {
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  setPersistence,
  signInWithCustomToken,
} from 'firebase/auth';
import useSWRMutation from 'swr/mutation';
import { LoginMethod, loginWithAccessCode } from '@/api/auth';
import { StorageType, useBrowserStorage } from '@/hooks/useBrowserStorage';
import { useLocalStorage } from '@/hooks/useLocalStorage';

export const useLoginWithAccessCodeMutation = () => {
  const [rememberMe] = useLocalStorage('rememberMe', false);
  const [, setAccessCodeId] = useBrowserStorage(
    'accessCodeId',
    '',
    rememberMe ? StorageType.Local : StorageType.Session
  );

  const { trigger, isMutating, data, error, reset } = useSWRMutation(
    '/login?method=accessCode',
    async (_, { arg: accessCode }: { arg: string }) => {
      // backend login (request customToken)
      const { customToken, ...data } = await loginWithAccessCode(accessCode, LoginMethod.AccessCode);
      // firebase login
      const auth = getAuth();
      setPersistence(auth, rememberMe ? browserLocalPersistence : browserSessionPersistence);
      await signInWithCustomToken(auth, customToken);
      // persist accessCodeId
      setAccessCodeId(data.accessCode.id);

      return data;
    }
  );

  return {
    trigger,
    isMutating,
    data,
    error,
    reset,
  };
};
